export const environment = {

    apiBaseUrl: window["env"]["apiBaseUrl"] || 'https://pgis-lite.qbit.lv',
    production: window["env"]["production"] === 'true' ? true : false

};
